import { DialogManager } from "../../Managers/DialogManager";
import { ApplicationData } from "../ApplicationData";
import { CheckboxView } from "./CheckboxView";

export class BatchDialogView extends CheckboxView {
  constructor(options) {
    super(options);
    this.successfulItems = [];
    this.errors = [];

    this.batchErrorMessage = "";
    this.secondaryErrorMessage = "";

    this.resetCheckboxes =
      options.resetCheckboxes == undefined ? true : options.resetCheckboxes;
  }
  openBatchDialog(options, callback) {
    var _this = this,
      event = options.event;

    this.batchErrorMessage = options.batchErrorMessage || "";
    this.secondaryErrorMessage = options.secondaryErrorMessage || "";

    if (this.resetCheckboxes) {
      this.setAllCheckboxes(false);
    }

    _this.splitResults(event);

    if (_this.errors.length > 0) {
      /*
       * Use the passed in error message title and create a list of the errored items
       */
      var errorContent = "<h3>" + _this.batchErrorMessage + "</h3>";
      errorContent = _this.getTitleList(_this.errors, errorContent);
      DialogManager.show({
        content: errorContent,
        dialogTitle: ApplicationData.language.errorDialogTitle,
        okText: ApplicationData.language.ok,
        showCancel: false,
        closeCallback: function (event) {
          callback(_this.successfulItems);
        },
      });
    } else {
      callback(_this.successfulItems);
    }
  }
  splitResults(event) {
    var _this = this;

    /*
     * Pull out the errors into an array
     */
    _this.successfulItems = [];
    _this.errors = [];

    $.each(event.data, function (i, loanInfo) {
      if (loanInfo.success === true) {
        _this.successfulItems.push(loanInfo);
      } else {
        _this.errors.push(loanInfo);
      }
    });
  }
  //loop the items and call a function to extra the data
  getTitleList(items, contentString) {
    var _this = this;
    contentString += '<ul class="titleList">';
    $.each(items, function (index, item) {
      //this getResponseStringById is meant to be overridden in the sub class.
      contentString += "<li>" + _this.getResponseStringById(item) + "</li>";
    });
    contentString += "</ul>";
    contentString += "<p>" + _this.secondaryErrorMessage + "</p>";
    return contentString;
  }
  getResponseStringById(item) {
    return "";
  }
}
